import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { syncAllPending } from './servicios/offlineSync';
import { AuthProvider, AuthContext } from './context/AuthContext';
import Login from './modulos/login/Login';
import Diseno from './comun/Diseno';
import ListaUsuarios from './modulos/usuarios/ListaUsuarios';
import PanelClinica from './modulos/clinica/PanelClinica';
import Bodega from './modulos/clinica/Bodega';
import Pacientes from './modulos/clinica/Pacientes';
import CertificadoVisual from './modulos/clinica/CertificadoVisual';
import Agenda from './modulos/clinica/Agenda';
import Tratamientos from './modulos/clinica/Tratamientos';
import Procedimientos from './modulos/clinica/Procedimientos';
import Recepcion from './modulos/clinica/Recepcion';
import HistoriaClinicaVisual from './modulos/clinica/HistoriaClinicaVisual';
import Consultas from './modulos/clinica/Consultas';
import Reportes from './modulos/clinica/Reportes';
import RegistroMensual from './modulos/clinica/RegistroMensual';
import Impresoras from './modulos/clinica/Impresoras';
import DisenoClinica from './modulos/clinica/DisenoClinica';
import Gastos from './modulos/clinica/Gastos';

import CieCodes from './modulos/clinica/CieCodes';
import ClinicalTerms from './modulos/clinica/ClinicalTerms';
import GraficosConsentimiento from './modulos/clinica/GraficosConsentimiento';
import RecordatoriosCorreo from './modulos/clinica/RecordatoriosCorreo';
import Facturacion from './modulos/clinica/Facturacion';
import logo from './assets/logo.png';
import './App.css';

// Componente para proteger rutas
const PrivateRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div>Cargando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <Diseno>{children}</Diseno>;
};

const ClinicRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <div>Cargando...</div>;
  if (!user) return <Navigate to="/login" />;

  // Usamos el diseño general para todos, la barra lateral filtrará los items
  return <Diseno>{children}</Diseno>;
};

// Dashboard simple
const Dashboard = () => {
  const { user } = useContext(AuthContext);
  const roleName = user?.role_details?.name;
  
  if (roleName !== 'SUPER_ADMIN' && !user?.is_superuser) {
      return <Navigate to="/clinica/agenda" />;
  }

  return (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh',
    backgroundColor: '#ffffff',
    color: 'var(--primary-color)',
    textAlign: 'center',
    borderRadius: '16px',
    padding: '3rem',
    margin: '1rem',
    boxShadow: '0 4px 20px rgba(24, 40, 72, 0.1)',
    border: '1px solid var(--border-color)'
  }}>
    <img src={logo} alt="Vision-Click" style={{ height: '180px', marginBottom: '2rem', objectFit: 'contain', filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))' }} />
    <h2 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>Bienvenido a Vision-Click</h2>
    <p style={{ fontSize: '1.2rem', opacity: 0.9 }}>Seleccione una opción del menú lateral para comenzar a administrar su negocio.</p>
  </div>
  );
};

const App = () => {
    useEffect(() => {
        const handleOnline = () => {
            console.log("Conexión restaurada. Intentando sincronizar datos offline...");
            syncAllPending();
        };

        window.addEventListener('online', handleOnline);
        
        // Intentar sincronizar al cargar la app por primera vez si hay internet
        if (navigator.onLine) {
            syncAllPending();
        }

        return () => window.removeEventListener('online', handleOnline);
    }, []);

    return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />

          <Route path="/users" element={
            <PrivateRoute>
              <ListaUsuarios />
            </PrivateRoute>
          } />

          {/* Rutas de la Clínica Óptica */}
          <Route path="/clinica" element={
            <ClinicRoute>
              <PanelClinica />
            </ClinicRoute>
          } />
          <Route path="/clinica/pacientes" element={
            <ClinicRoute>
              <Pacientes />
            </ClinicRoute>
          } />
          <Route path="/clinica/certificado-visual" element={
            <ClinicRoute>
              <CertificadoVisual />
            </ClinicRoute>
          } />
          <Route path="/clinica/agenda" element={
            <ClinicRoute>
              <Agenda />
            </ClinicRoute>
          } />
          <Route path="/clinica/servicios" element={
            <ClinicRoute>
              <Tratamientos />
            </ClinicRoute>
          } />
          <Route path="/clinica/procedimientos" element={
            <ClinicRoute>
              <Procedimientos />
            </ClinicRoute>
          } />
          <Route path="/clinica/graficos-consentimiento" element={
            <ClinicRoute>
              <GraficosConsentimiento />
            </ClinicRoute>
          } />
          <Route path="/clinica/recepcion" element={
            <ClinicRoute>
              <Recepcion />
            </ClinicRoute>
          } />
          <Route path="/clinica/historia-visual" element={
            <ClinicRoute>
              <HistoriaClinicaVisual />
            </ClinicRoute>
          } />
          <Route path="/clinica/registro-mensual" element={
            <ClinicRoute>
              <RegistroMensual />
            </ClinicRoute>
          } />
          <Route path="/clinica/consultas" element={
            <ClinicRoute>
              <Consultas />
            </ClinicRoute>
          } />
          <Route path="/clinica/bodega" element={
            <ClinicRoute>
              <Bodega />
            </ClinicRoute>
          } />

          <Route path="/clinica/gastos" element={
            <ClinicRoute>
              <Gastos />
            </ClinicRoute>
          } />
          <Route path="/clinica/reports" element={
            <ClinicRoute>
              <Reportes />
            </ClinicRoute>
          } />
          <Route path="/clinica/facturacion" element={
            <ClinicRoute>
              <Facturacion />
            </ClinicRoute>
          } />
          <Route path="/clinica/recordatorios" element={
            <ClinicRoute>
              <RecordatoriosCorreo />
            </ClinicRoute>
          } />
          <Route path="/clinica/printers" element={
            <ClinicRoute>
              <Impresoras />
            </ClinicRoute>
          } />
          <Route path="/clinica/cie-codes" element={
            <ClinicRoute>
              <CieCodes />
            </ClinicRoute>
          } />
          <Route path="/clinica/clinical-terms" element={
            <ClinicRoute>
              <ClinicalTerms />
            </ClinicRoute>
          } />

          {/* Redirigir cualquier otra ruta al inicio */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
